<template>
    <div class="rules-input-wrapper">
        <div class="rules-input-edit">
            <input
                :placeholder="placeholder"
                v-model="value.userContact"
                type="text"
                :class="{ error: value.tips && value.tips !== 'success', 'input-disabled': disabled }"
                @keypress="keyPressHandler"
                @input="inputChange"
                :disabled="disabled"
            />
        </div>
        <div
            class="rules-input-tip"
            :class="{ 'input-tip-error': value.tips && value.tips !== 'success' }"
            v-if="value.tips && value.tips !== 'success'"
        >
            <i></i>{{ value.tips }}
        </div>
        <div class="rules-input-tip input-tip-right" v-else v-show="value.tips === 'success'">
            <i class="success-icon"></i>
        </div>
    </div>
</template>

<script>
import { checkAll } from "@/views/zhiji/js/common/inputValidata.js";

export default {
    name: "RulesInput",
    props: ["placeholder", "initValue", "rules", "disabled", "tips"],
    data() {
        return {
            value: {
                userContact: this.initValue || "",
                tips: this.tips || ""
            }
        };
    },
    watch: {
        tips(newVal) {
            this.value.tips = newVal;
        },
        initValue(newVal) {
            if (this.value.userContact != newVal) {
                this.value.userContact = newVal;
            }
        }
    },
    methods: {
        inputChange() {
            this.value.tips = checkAll(this.rules, this.value.userContact);
            this.$emit("inputChange", this.value);
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.$emit("inputChange", this.value);
        }
    }
};
</script>

<style lang="less" scoped>
.rules-input-wrapper {
    position: relative;
    width: 100%;

    .rules-input-edit {
        position: relative;
        width: 100%;
        input {
            border-radius: 4px;
            padding: 6px 8px 7px 8px;
            background: #fff;
            width: 100%;
            border: solid 1px #d8e4f0;
            box-sizing: border-box;
        }

        .error {
            border-color: #e03838;
        }

        .input-disabled {
            background: #f2f7fb !important;
            border-color: #e1eaf2 !important;
        }
    }

    .rules-input-tip {
        position: absolute;
        top: 10px;
        font-size: 12px;
        line-height: 12px;
        left: 99%;
        white-space: nowrap;

        i {
            width: 18px;
            height: 18px;
            vertical-align: -4px;
            display: inline-block;
            background: url("@{zhijiStaticImagePath}class-spr.png");
        }
    }

    .input-tip-right {
        .success-icon {
            background-position: -240px -50px;
            margin-left: 8px;
        }
    }

    .input-tip-error {
        left: 0px;
        top: 35px;
        color: #e03838;

        i {
            background-position: -222px -50px;
        }
    }
}
</style>
